import LanguagePicker from './LanguagePicker';
import Footer from './Footer';
import { Lang, TranslationKey } from '../i18n';
import legalContent from '../legalText';

interface LegalPagesProps {
    page: 'mentions' | 'privacy' | 'cgv';
    lang: Lang;
    t: (key: TranslationKey, vars?: Record<string, string>) => string;
    onBack: () => void;
    onChangeLang: (lang: Lang) => void;
    onLegalClick?: (page: 'mentions' | 'privacy' | 'cgv') => void;
}

const LegalPages = ({ page, lang, t, onBack, onChangeLang, onLegalClick }: LegalPagesProps) => {

    const currentContent = legalContent[lang] || legalContent.en;

    const renderMentionsLegales = () => currentContent.mentions();
    const renderPrivacy = () => currentContent.privacy();
    const renderCGV = () => currentContent.cgv();

    return (
        <div className="legal-page" dir="ltr" lang="fr">
            <header className="legal-header">
                <button className="ghost-button" type="button" onClick={onBack}>
                    ← Retour
                </button>
                <LanguagePicker value={lang} onChange={onChangeLang} compact />
            </header>
            <main className="legal-content">
                {page === 'mentions' && renderMentionsLegales()}
                {page === 'privacy' && renderPrivacy()}
                {page === 'cgv' && renderCGV()}
            </main>
            <Footer t={t} onLegalClick={onLegalClick} />
        </div>
    );
};

export default LegalPages;
